define('modules/page_listing/views/tag_itemview',['require','exports','module','base/itemview','ldsh!../templates/tag_itemview'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/tag_itemview"),
    tagName: "li",
    className: "ed-tag",
    triggers: {
      "click .js-delete-tag": "tag:delete"
    }
  });
});

